import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { DISPATCH_ID, json, CURRENCY, FORMAT_NUMBER } from '../../libs/utils/Const';
import { isSalesDocument, isPurchaseDocument } from '../../libs/utils/GlobalFunc';
const borderColor = '#90e5fc'

const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        display: 'flex',
        height: 15,
        fontSize: 8,
    },
    description: {
        width: '85%',
        textAlign: 'right',
        paddingRight: 8,
    },
    total: {
        width: '15%',
        textAlign: 'center',
        paddingRight: 8,
        backgroundColor: '#e2e2e2',
        fontStyle: 'bold'
    },

    // Estilos de contenedores
    outerContainer: {
        width: '100%',
        alignItems: 'flex-end',
        marginTop: 10,
    },

    // Estilos de tabla
    tableContainer: {
        borderWidth: 1,
        borderColor: '#000',
        width: 270,
    },
    tableRow: {
        flexDirection: 'row',
        height: 20,
        borderBottomWidth: 1,
        borderColor: '#000',
    },
    lastRow: {
        borderBottomWidth: 0,
    },
    colDesc: {
        flex: 2.5,
        borderRightWidth: 1,
        borderColor: '#000',
        justifyContent: 'center',
        paddingRight: 8,
    },
    colTotal: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: 8,
    },
    textDesc: {
        fontSize: 7,
        textAlign: 'right',
    },
    textTotal: {
        fontSize: 7,
    },
    textAmount: {
        fontSize: 7,
    },

    // Estilos para "SON:"
    sonContainer: {
        marginTop: 10,
        padding: 8,
        marginRight: 10,
        width: '100%',
        alignItems: 'flex-start',
    },
    observacionesLabel: {
        fontSize: 8,
        fontWeight: 'bold',
    },
    observacionesText: {
        fontSize: 8,
    },

    observacionesContainer: {
        marginTop: 10,
        marginRight: 10,
        width: '100%',
        alignItems: 'flex-start',
    },

    observacionesConta: {
       padding: 8,
       borderWidth: 1,
       borderColor: '#000',
    },

    sonLabel: {
        fontSize: 8,
        fontWeight: 'bold',
    },
    sonText: {
        fontSize: 8,
    },

    // Estilos para Observaciones (sección completa)
    observacionesSection: {
        marginTop: 15,
        width: '100%',
        borderWidth: 1,
        borderColor: '#000',
    },
    observacionesHeader: {
        backgroundColor: '#2c5f7c',
        padding: 5,
    },
    observacionesHeaderText: {
        color: '#fff',
        fontSize: 9,
        fontWeight: 'bold',
    },
    observacionesContent: {
        height: 80,
        backgroundColor: '#fff',
        padding: 5,
    },

    // Estilos para Firmas
    firmasContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 25,
        paddingHorizontal: 10,
        width: '100%',
    },
    firmaBox: {
        width: '30%',
        alignItems: 'center',
    },
    firmaLinea: {
        width: '100%',
        borderBottomWidth: 1,
        borderColor: '#000',
        marginBottom: 3,
    },
    firmaLabel: {
        fontSize: 7,
        textAlign: 'center',
    },
    termsContainer: {
        width: '97%',
        margin: '15 auto',
        paddingBottom: 20,
        display: 'flex',
        flexDirection: 'row',
    },

    termsContainerOC: {
        width: '100%',
        margin: '15 auto',
        paddingBottom: 20,
        display: 'flex',
        flexDirection: 'row',
    },
    Column1: {
        display: 'flex',
        minWidth: '80%',
        maxWidth: '80%',
        paddingRight: '5px',
        fontSize: '3.5',
        textAlign: 'justify',
    },
    Column2: {
        display: 'flex',
        minWidth: '20%',
        maxWidth: '20%',
        paddingLeft: '5px',
        fontSize: '3.5',
        textAlign: 'justify',
    },
    Column1OC: {
        display: 'flex',
        minWidth: '60%',
        maxWidth: '60%',
        paddingRight: '5px',
        fontSize: '3.5',
        textAlign: 'justify',
    },
    Column2OC: {
        display: 'flex',
        minWidth: '40%',
        maxWidth: '40%',
        paddingLeft: '5px',
        paddingRight: 0,
        marginRight: 0,
        fontSize: '3.5',
        textAlign: 'justify',
    },

    descriptionOC1: {
        width: '60%',
        textAlign: 'left',
        paddingRight: 8,
    },
    totalOC1: {
        width: '40%',
        textAlign: 'right',
        paddingRight: 8,
        // backgroundColor: '#e2e2e2',
        fontStyle: 'bold'
    },
    descriptionOC: {
        width: '85%',
        textAlign: 'left',
        paddingRight: 8,
    },
    totalOC: {
        width: '15%',
        textAlign: 'right',
        paddingRight: 8,
        // backgroundColor: '#e2e2e2',
        fontStyle: 'bold'
    },
    commentContainer: {
        width: '90%',
        fontSize: 8,
    },
    comment: {
        alignSelf: 'stretch',
        width: '100%',
        flexWrap: 'wrap',
    }

});

const creditNoteStyles = StyleSheet.create({
    creditNoteContainer: {
        padding: 12,
    },
    creditNoteHeader: {
        flexDirection: 'row',
        marginBottom: 10,
        justifyContent: 'space-between',
    },
    totalSection: {
        width: '25%',
        padding: 8,
        fontSize: 8,
        flexDirection: 'row',
        borderWidth: 1,
        borderColor: '#000000',
        justifyContent: 'space-between',
    },
    totalLabel: {
        fontSize: 7,
        fontStyle: 'bold',
    },
    totalValue: {
        fontSize: 8,
        fontStyle: 'bold',
    },
    creditNoteFooter: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingTop: 15,
    },
    signatureBox: {
        width: '45%',
        borderWidth: 1,
        borderColor: '#000000',
        padding: 8,
    },
    signatureLabel: {
        fontSize: 7,
        fontStyle: 'bold',
        marginBottom: 8,
        textAlign: 'center',
    },
    signatureCompany: {
        fontSize: 7,
        marginBottom: 4,
        textAlign: 'left',
    },
    signatureInfo: {
        fontSize: 7,
    },
});

const round = (num) => {
    let m = Number((Math.abs(num) * 100).toPrecision(15));
    return Math.round(m) / 100 * Math.sign(num);
}

// const refreshTotal = (header, Items) => {
//     Items.map(item => {
//         item.TaxeResult = round(item.ImpuestoRow/ (header.DocRate || 1)).toFixed(2);
//         item.Total = round(item.LineTotal / (header.DocRate || 1)).toFixed(2);
//     });
//     let subTotal = 0;
//     let impuestos = 0;
//     let discount = 0;
//     let total = 0;

//     for (let index = 0; index < Items.length; index++) {
//         const item = Items[index];
//         item.TaxeResult = round(item.ImpuestoRow/ (header.DocRate || 1)).toFixed(2) ;
//         subTotal += Number(item.Total);         
//         impuestos += parseFloat(parseFloat(item.TaxeResult).toFixed(2));
//     }

//     discount = subTotal * (header.DiscPrcnt / 100);
//     total =  parseFloat(parseFloat(subTotal).toFixed(2) - parseFloat(discount).toFixed(2) ) + parseFloat(parseFloat(impuestos).toFixed(2));

//     let totals = {
//         Subtotal: parseFloat(subTotal).toFixed(2),
//         Discount: parseFloat(discount).toFixed(2),
//         Taxes :parseFloat(impuestos).toFixed(2),
//         Total: parseFloat(total).toFixed(2),
//     }
//     return totals;
// };

// Convierte un número a texto en SOLES (formato Perú)
const numeroALetras = (num) => {
    const unidades = [
        "", "UNO", "DOS", "TRES", "CUATRO", "CINCO",
        "SEIS", "SIETE", "OCHO", "NUEVE"
    ];

    const decenas = [
        "", "DIEZ", "VEINTE", "TREINTA", "CUARENTA",
        "CINCUENTA", "SESENTA", "SETENTA", "OCHENTA", "NOVENTA"
    ];

    const centenas = [
        "", "CIENTO", "DOSCIENTOS", "TRESCIENTOS",
        "CUATROCIENTOS", "QUINIENTOS", "SEISCIENTOS",
        "SETECIENTOS", "OCHOCIENTOS", "NOVECIENTOS"
    ];

    const especiales = {
        11: "ONCE", 12: "DOCE", 13: "TRECE", 14: "CATORCE",
        15: "QUINCE", 20: "VEINTE"
    };

    const convertir = (n) => {
        if (n === 0) return "CERO";

        if (especiales[n]) return especiales[n];

        if (n < 10) return unidades[n];

        if (n < 20) return "DIECI" + unidades[n - 10];

        if (n < 100) {
            let d = Math.floor(n / 10);
            let r = n % 10;
            return decenas[d] + (r ? " Y " + unidades[r] : "");
        }

        if (n < 1000) {
            if (n === 100) return "CIEN";
            let c = Math.floor(n / 100);
            let r = n % 100;
            return centenas[c] + (r ? " " + convertir(r) : "");
        }

        if (n < 1000000) {
            let miles = Math.floor(n / 1000);
            let r = n % 1000;
            return (miles === 1 ? "MIL" : convertir(miles) + " MIL") + (r ? " " + convertir(r) : "");
        }

        return "";
    };

    const entero = Math.floor(num);
    const decimal = Math.round((num - entero) * 100);

    return `${convertir(entero)} CON ${decimal.toString().padStart(2, '0')}/100 SOLES`;
};


const refreshTotal = (header, Items, view, format) => {
    const docCur = header.DocCur || '';
    let subTotal = 0;
    let subtotalDpm = 0;
    let impuestos = 0;
    let discount = 0;
    let total = 0;
    let anticipoTotal = parseFloat(header.DpmAmnt || 0);
    const isPurchaseDoc = isPurchaseDocument(view, header?.ObjType);
    const isSalesDoc = isSalesDocument(view, header?.ObjType);

    //moneda extranjera
    if (docCur !== CURRENCY && ((view === 'PurchaseOrder' && format === 2) || (isPurchaseDoc || isSalesDoc))) {
        let anticipoTotalFC = parseFloat(header.DpmAmntFC || 0); // Anticipo en moneda extranjera
        total = Number.parseFloat(header.DocTotalFC || 0);
        impuestos = Number.parseFloat(header.VatSumFC || 0);
        subTotal = total - impuestos;
        discount = Number.parseFloat(header.DiscSumFC || 0);

        return {
            SubtotalOriginal: subTotal.toFixed(2),
            AnticipoTotal: parseFloat(anticipoTotalFC).toFixed(2),
            Subtotal: subTotal.toFixed(2),
            Discount: discount.toFixed(2),
            Taxes: impuestos.toFixed(2),
            Total: total.toFixed(2),
            DocCur: docCur,
        };
    }

    // moneda local
    Items.map(item => {
        let impuesto = round(parseFloat(item.LineTotal).toFixed(2) * (item.Impuesto / 100));
        item.TaxeResult = Number(Number(impuesto)).toFixed(2);

        subTotal += Number(item.LineTotal);
        impuestos += parseFloat(Number(item.TaxeResult).toFixed(2));
    });
    let iva = (impuestos * 100) / subTotal;
    subtotalDpm = subTotal - anticipoTotal;
    discount = subtotalDpm * (header.DiscPrcnt / 100);
    impuestos = subtotalDpm * (iva / 100);
    total = parseFloat(parseFloat(subtotalDpm).toFixed(2) - parseFloat(discount).toFixed(2)) + parseFloat(parseFloat(impuestos).toFixed(2));
    let totals = {
        SubtotalOriginal: parseFloat(subTotal).toFixed(2),
        AnticipoTotal: parseFloat(anticipoTotal).toFixed(2),
        Subtotal: parseFloat(subtotalDpm).toFixed(2),
        Discount: parseFloat(discount).toFixed(2),
        Taxes: parseFloat(impuestos).toFixed(2),
        Total: parseFloat(total).toFixed(2),
        DocCur: docCur,
    }
    return totals;
};

const TableFooter = ({ header, items, view, format }) => {
    let order = refreshTotal(header, items, view, format);

    if (view === 'creditNote' && header.U_BPP_MDTD === 'DV') {
        return (
            <>
                <View style={creditNoteStyles.creditNoteContainer}>
                    <View style={creditNoteStyles.creditNoteHeader}>
                        <View style={{ flex: 1 }} />
                        <View style={creditNoteStyles.totalSection}>
                            <Text style={creditNoteStyles.totalLabel}>TOTAL, S/.</Text>
                            <Text style={creditNoteStyles.totalValue}>{Number.parseFloat(order.Total).toFixed(2)}</Text>
                        </View>
                    </View>

                    <View style={creditNoteStyles.creditNoteFooter}>
                        <View style={creditNoteStyles.signatureBox}>
                            <Text style={creditNoteStyles.signatureLabel}>Recibí Conforme</Text>
                            <Text style={creditNoteStyles.signatureCompany}>{header?.CardName || ''}</Text>
                            <Text style={creditNoteStyles.signatureInfo}>DOI/DNI(RUC): {header.LicTradNum || ''}</Text>
                        </View>

                        <View style={creditNoteStyles.signatureBox}>
                            <Text style={creditNoteStyles.signatureLabel}>Entregué Conforme</Text>
                            <Text style={creditNoteStyles.signatureCompany}>{header?.U_NAME || ''}</Text>
                            <Text style={creditNoteStyles.signatureInfo}>DOI/DNI(RUC): {''}</Text>
                        </View>
                    </View>
                </View>
            </>
        );
    }

    if (view === 'invoice' && header.U_BPP_MDTD === 'CU') {
        return (
            <>
                <View style={creditNoteStyles.creditNoteContainer}>
                    <View style={creditNoteStyles.creditNoteHeader}>
                        <View style={{ flex: 1 }} />
                        <View style={creditNoteStyles.totalSection}>
                            <Text style={creditNoteStyles.totalLabel}>TOTAL, S/.</Text>
                            <Text style={creditNoteStyles.totalValue}>{Number.parseFloat(order.Total).toFixed(2)}</Text>
                        </View>
                    </View>

                    <View style={creditNoteStyles.creditNoteFooter}>
                        <View style={creditNoteStyles.signatureBox}>
                            <Text style={creditNoteStyles.signatureLabel}>Recibí Conforme</Text>
                            <Text style={creditNoteStyles.signatureCompany}>{header?.CardName || ''}</Text>
                            <Text style={creditNoteStyles.signatureInfo}>DOI/DNI(RUC): {header.LicTradNum || ''}</Text>
                        </View>

                        <View style={creditNoteStyles.signatureBox}>
                            <Text style={creditNoteStyles.signatureLabel}>Entregué Conforme</Text>
                            <Text style={creditNoteStyles.signatureCompany}>{header?.Empleado || ''}</Text>
                            <Text style={creditNoteStyles.signatureInfo}>DOI/DNI(RUC): {header?.U_BPP_MDSD || ''}</Text>
                        </View>
                    </View>
                </View>
            </>
        );
    }

    if (view === 'orderSales' && header.U_RS_TIPOV === 'ENVASA') {
        return (
            <>
                <View style={styles.observacionesSection}>
                    <View style={styles.observacionesHeader}>
                        <Text style={styles.observacionesHeaderText}>OBSERVACIONES</Text>
                    </View>
                    <View style={styles.observacionesContent}>
                    </View>
                </View>

                <View style={styles.firmasContainer}>
                    <View style={styles.firmaBox}>
                        <View style={styles.firmaLinea}></View>
                        <Text style={styles.firmaLabel}>Firma de jefe de planta</Text>
                    </View>
                    <View style={styles.firmaBox}>
                        <View style={styles.firmaLinea}></View>
                        <Text style={styles.firmaLabel}>Firma de seguridad</Text>
                    </View>
                    <View style={styles.firmaBox}>
                        <View style={styles.firmaLinea}></View>
                        <Text style={styles.firmaLabel}>Firma de cliente</Text>
                    </View>
                </View>
            </>
        );
    }

    if (view === 'invoice') {
        return (
            <View>
                <View style={styles.row}>
                    <Text style={styles.description}>Subtotal</Text>
                    <Text style={styles.total}>{Number.parseFloat(order.Subtotal).toFixed(2)}</Text>
                </View>
                <View style={styles.row}>
                    <Text style={styles.description}>Anticipo total</Text>
                    <Text style={styles.total}>{Number.parseFloat(order.AnticipoTotal).toFixed(2)}</Text>
                </View>
                <View style={styles.row}>
                    <Text style={styles.description}>Descuento</Text>
                    <Text style={styles.total}>{Number.parseFloat(order.Discount).toFixed(2)}</Text>
                </View>
                <View style={styles.row}>
                    <Text style={styles.description}>IGV</Text>
                    <Text style={styles.total}>{Number.parseFloat(order.Taxes).toFixed(2)}</Text>
                </View>
                <View style={styles.row}>
                    <Text style={styles.description}>Total</Text>
                    <Text style={styles.total}>{Number.parseFloat(order.Total).toFixed(2)}</Text>
                </View>
            </View>
        );
    }

    if (view === 'PurchaseOrder' && format === 2) {

        return (
            <View style={styles.termsContainerOC}>
                <View style={styles.Column1OC}>
                    <View style={styles.row}>
                        <Text style={[{ textDecoration: 'underline' }]}>REQUERIMIENTOS</Text>
                    </View>
                    <View style={styles.commentContainer}>
                        <Text style={styles.comment} wrap>{header?.Comments || ''}</Text>
                    </View>
                </View>
                <View style={[styles.Column2OC, { justifyContent: 'flex-end', alignItems: 'flex-end' }]}>
                    <View style={{ width: '100%' }}>
                    <View style={[styles.row, { borderBottom: '1px solid #000' }]}>
                        <Text style={[styles.descriptionOC1, { textAlign: 'right' }]}>Valor de la venta:</Text>
                        <Text style={[styles.totalOC1, { textAlign: 'right' }]}>{`${order?.DocCur ? `${order?.DocCur} ` : ''}${FORMAT_NUMBER.new(order.Subtotal, '')}`}</Text>
                    </View>
                    <View style={[styles.row, { borderBottom: '1px solid #000' }]}>
                        <Text style={[styles.descriptionOC1, { textAlign: 'right' }]}>IGV 18%:</Text>
                        <Text style={[styles.totalOC1, { textAlign: 'right' }]}>{`${order?.DocCur ? `${order?.DocCur} ` : ''}${FORMAT_NUMBER.new(order.Taxes, '')}`}</Text>
                    </View>
                    {/* <View style={[{ flexDirection: 'row', display: 'flex', }]}>
                        <Text style={[{ width: '85%' }]}></Text>
                        <Text style={[{ width: '100%', borderTop: '1px', paddingRight: '0px', marginRight: '0px' }]}></Text>
                    </View> */}
                    <View style={[styles.row]}>
                        <Text style={[styles.descriptionOC1, { textAlign: 'right', fontWeight: 'bold' }]}>Precio Total:</Text>
                        <Text style={[styles.totalOC1, { textAlign: 'right', fontWeight: 'bold' }]}>{`${order?.DocCur ? `${order?.DocCur} ` : ''}${FORMAT_NUMBER.new(order.Total, '')}`}</Text>
                    </View>
                    </View>
                </View>
            </View>
        );
    }

    if (view === 'debitNote') {
        return (
            <>
                <View style={styles.outerContainer}>
                    <View style={styles.tableContainer}>
                        <View style={styles.tableRow}>
                            <View style={styles.colDesc}>
                                <Text style={styles.textDesc}>Total Valor de Venta - Operaciones Gravadas:</Text>
                            </View>
                            <View style={styles.colTotal}>
                                <Text style={styles.textTotal}>S/</Text>
                                <Text style={styles.textAmount}>{Number.parseFloat(order.Subtotal).toFixed(2)}</Text>
                            </View>
                        </View>

                        <View style={styles.tableRow}>
                            <View style={styles.colDesc}>
                                <Text style={styles.textDesc}>IGV (18.00 %):</Text>
                            </View>
                            <View style={styles.colTotal}>
                                <Text style={styles.textTotal}>S/</Text>
                                <Text style={styles.textAmount}>{Number.parseFloat(order.Taxes).toFixed(2)}</Text>
                            </View>
                        </View>

                        <View style={[styles.tableRow, styles.lastRow]}>
                            <View style={styles.colDesc}>
                                <Text style={styles.textDesc}>Importe Total:</Text>
                            </View>
                            <View style={styles.colTotal}>
                                <Text style={styles.textTotal}>S/</Text>
                                <Text style={styles.textAmount}>{Number.parseFloat(order.Total).toFixed(2)}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.sonContainer}>
                        <Text style={styles.sonLabel}>SON: <Text style={styles.sonText}>{numeroALetras(Number(order.Total))}</Text>
                        </Text>
                    </View>
                    <View style={styles.observacionesConta}>
                    <View style={styles.observacionesContainer}>
                        <Text style={styles.observacionesLabel}>Observaciones: <Text style={styles.observacionesText}>NOTA DE DEBITO EMITIDA POR DIFERENCIA DE PRECIO AL MOMENTO DE COBRAR FLETE (NO SE CONSIDERO EL IGV)//F755002091//002092//002093/002094
                            Detracciones - Numero de Cuenta en el B.N:00000370592 Detracciones - Código de Bienes y Sevicios: 027</Text>
                        </Text>
                    </View>
                    </View>
                </View>
            </>
        )
    }

    if (view === 'creditNote') {
        return (
            <>
                <View style={styles.outerContainer}>
                    <View style={styles.tableContainer}>
                        <View style={styles.tableRow}>
                            <View style={styles.colDesc}>
                                <Text style={styles.textDesc}>Total Valor de Venta - Operaciones Gravadas:</Text>
                            </View>
                            <View style={styles.colTotal}>
                                <Text style={styles.textTotal}>S/</Text>
                                <Text style={styles.textAmount}>{Number.parseFloat(order.Subtotal).toFixed(2)}</Text>
                            </View>
                        </View>

                        <View style={styles.tableRow}>
                            <View style={styles.colDesc}>
                                <Text style={styles.textDesc}>IGV (18.00 %):</Text>
                            </View>
                            <View style={styles.colTotal}>
                                <Text style={styles.textTotal}>S/</Text>
                                <Text style={styles.textAmount}>{Number.parseFloat(order.Taxes).toFixed(2)}</Text>
                            </View>
                        </View>

                        <View style={[styles.tableRow, styles.lastRow]}>
                            <View style={styles.colDesc}>
                                <Text style={styles.textDesc}>Importe Total:</Text>
                            </View>
                            <View style={styles.colTotal}>
                                <Text style={styles.textTotal}>S/</Text>
                                <Text style={styles.textAmount}>{Number.parseFloat(order.Total).toFixed(2)}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.sonContainer}>
                        <Text style={styles.sonLabel}>SON: <Text style={styles.sonText}>{numeroALetras(Number(order.Total))}</Text>
                        </Text>
                    </View>
                    <View style={styles.observacionesConta}>
                        <View style={styles.observacionesContainer}>
                            <Text style={styles.observacionesLabel}>Observaciones: <Text style={styles.observacionesText}>NOTA DE DEBITO EMITIDA POR DIFERENCIA DE PRECIO AL MOMENTO DE COBRAR FLETE (NO SE CONSIDERO EL IGV)//F755002091//002092//002093/002094
                                Detracciones - Numero de Cuenta en el B.N:00000370592 Detracciones - Código de Bienes y Sevicios: 027</Text>
                            </Text>
                        </View>
                    </View>
                </View>
            </>
        )
    }

    if (view === 'invoice' && header.U_BPP_MDTD === '03') {
        return (
            <>
                <View style={styles.outerContainer}>
                    <View style={styles.tableContainer}>
                        <View style={styles.tableRow}>
                            <View style={styles.colDesc}>
                                <Text style={styles.textDesc}>Total Valor de Venta - Operaciones Gravadas:</Text>
                            </View>
                            <View style={styles.colTotal}>
                                <Text style={styles.textTotal}>S/</Text>
                                <Text style={styles.textAmount}>{Number.parseFloat(order.Subtotal).toFixed(2)}</Text>
                            </View>
                        </View>

                         <View style={styles.tableRow}>
                            <View style={styles.colDesc}>
                                <Text style={styles.textDesc}> Total Valor de Venta - Operaciones Gratuitas:</Text>
                            </View>
                            <View style={styles.colTotal}>
                                <Text style={styles.textTotal}>S/</Text>
                                <Text style={styles.textAmount}>{''}</Text>
                            </View>
                        </View>

                        <View style={styles.tableRow}>
                            <View style={styles.colDesc}>
                                <Text style={styles.textDesc}>IGV (18.00 %):</Text>
                            </View>
                            <View style={styles.colTotal}>
                                <Text style={styles.textTotal}>S/</Text>
                                <Text style={styles.textAmount}>{Number.parseFloat(order.Taxes).toFixed(2)}</Text>
                            </View>
                        </View>

                        <View style={[styles.tableRow, styles.lastRow]}>
                            <View style={styles.colDesc}>
                                <Text style={styles.textDesc}>Importe Total:</Text>
                            </View>
                            <View style={styles.colTotal}>
                                <Text style={styles.textTotal}>S/</Text>
                                <Text style={styles.textAmount}>{Number.parseFloat(order.Total).toFixed(2)}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.sonContainer}>
                        <Text style={styles.sonLabel}>SON: <Text style={styles.sonText}>{numeroALetras(Number(order.Total))}</Text>
                        </Text>
                    </View>
                    <View style={styles.observacionesConta}>
                        <View style={styles.observacionesContainer}>
                            <Text style={styles.observacionesLabel}>Observaciones: <Text style={styles.observacionesText}>NOTA DE DEBITO EMITIDA POR DIFERENCIA DE PRECIO AL MOMENTO DE COBRAR FLETE (NO SE CONSIDERO EL IGV)//F755002091//002092//002093/002094
                                Detracciones - Numero de Cuenta en el B.N:00000370592 Detracciones - Código de Bienes y Sevicios: 027</Text>
                            </Text>
                        </View>
                    </View>
                </View>
            </>
        )
    }

     if (view === 'invoice') {
        return (
            <>
                <View style={styles.outerContainer}>
                    <View style={styles.tableContainer}>
                        <View style={styles.tableRow}>
                            <View style={styles.colDesc}>
                                <Text style={styles.textDesc}>Total Valor de Venta - Operaciones Gravadas:</Text>
                            </View>
                            <View style={styles.colTotal}>
                                <Text style={styles.textTotal}>S/</Text>
                                <Text style={styles.textAmount}>{Number.parseFloat(order.Subtotal).toFixed(2)}</Text>
                            </View>
                        </View>

                        <View style={styles.tableRow}>
                            <View style={styles.colDesc}>
                                <Text style={styles.textDesc}>IGV (18.00 %):</Text>
                            </View>
                            <View style={styles.colTotal}>
                                <Text style={styles.textTotal}>S/</Text>
                                <Text style={styles.textAmount}>{Number.parseFloat(order.Taxes).toFixed(2)}</Text>
                            </View>
                        </View>

                        <View style={[styles.tableRow, styles.lastRow]}>
                            <View style={styles.colDesc}>
                                <Text style={styles.textDesc}>Importe Total:</Text>
                            </View>
                            <View style={styles.colTotal}>
                                <Text style={styles.textTotal}>S/</Text>
                                <Text style={styles.textAmount}>{Number.parseFloat(order.Total).toFixed(2)}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableContainer}>
                        <View style={styles.tableRow}>
                            <View style={styles.colDesc}>
                                <Text style={styles.textDesc}> Importe referencial de la percepción (2.00 %):</Text>
                            </View>
                            <View style={styles.colTotal}>
                                <Text style={styles.textTotal}>S/</Text>
                                <Text style={styles.textAmount}>{''}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableContainer}>
                        <View style={styles.tableRow}>
                            <View style={styles.colDesc}>
                                <Text style={styles.textDesc}> TOTAL A PAGAR:</Text>
                            </View>
                            <View style={styles.colTotal}>
                                <Text style={styles.textTotal}>S/</Text>
                                <Text style={styles.textAmount}>{''}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.observacionesConta}>
                        <View style={styles.observacionesContainer}>
                            <Text style={styles.observacionesLabel}>Observaciones: <Text style={styles.observacionesText}>NOTA DE DEBITO EMITIDA POR DIFERENCIA DE PRECIO AL MOMENTO DE COBRAR FLETE (NO SE CONSIDERO EL IGV)//F755002091//002092//002093/002094
                                Detracciones - Numero de Cuenta en el B.N:00000370592 Detracciones - Código de Bienes y Sevicios: 027</Text>
                            </Text>
                        </View>
                    </View>
                </View>
            </>
        )
    }


    return (

        <View>
            {/* <View style={styles.row}>
                <Text style={styles.description}>Valor Bruto</Text>
                <Text style={styles.total}>{ Number.parseFloat(order.Total).toFixed(2)}</Text>
            </View> */}

            <View style={styles.row}>
                <Text style={styles.description}>Subtotal</Text>
                <Text style={styles.total}>{Number.parseFloat(order.Subtotal).toFixed(2)}</Text>
            </View>
            <View style={styles.row}>
                <Text style={styles.description}>Descuento</Text>
                <Text style={styles.total}>{Number.parseFloat(order.Discount).toFixed(2)}</Text>
            </View>
            <View style={styles.row}>
                <Text style={styles.description}>IGV</Text>
                <Text style={styles.total}>{Number.parseFloat(order.Taxes).toFixed(2)}</Text>
            </View>
            {/* <View style={styles.row}>
                <Text style={styles.description}>ISC</Text>
                <Text style={styles.total}>{ Number.parseFloat(0).toFixed(2)}</Text>
            </View> */}
            <View style={styles.row}>
                <Text style={styles.description}>Total</Text>
                <Text style={styles.total}>{Number.parseFloat(order.Total).toFixed(2)}</Text>
            </View>
        </View>


    )
};

export default TableFooter